export const getRootPathRedirection = (country?: string): string => {
  if (country === 'DE') {
    return ROUTES.BRANDS;
  }
  if (country === 'HU') {
    return ROUTES.PROGRAMS;
  }
  return ROUTES.DASHBOARD;
};

export const ROUTES = {
  DASHBOARD: '/dashboard',
  TEN_DLC_CAMPAIGNS: '/campaigns',
  TEN_DLC_CAMPAIGN_DETAILS: '/campaigns/:id',
  RCS_CAMPAIGNS: '/rcs-campaigns',
  RCS_CAMPAIGN_DETAILS: '/rcs-campaigns/:id',
  BRANDS: '/brands',
  BRAND_DETAIL: '/brands/:id',
  CSP: '/csps',
  EVENTS: '/events',
  INTEGRATIONS: '/integrations',
  WILD_CARD_CAMPAIGN: '/wildcard-campaigns/:id',
  PROGRAMS: '/programs',
  PROGRAM_DETAILS: '/programs/:id',
  SENDER_IDS: '/sender-ids',
};

export const SIDE_NAV_ENTRIES = {
  DASHBOARD: ROUTES.DASHBOARD,
  TEN_DLC_CAMPAIGNS: `${ROUTES.TEN_DLC_CAMPAIGNS}?ascendingOrder=false&sortField=createDate&status=ACTIVE`,
  RCS_CAMPAIGNS: `${ROUTES.RCS_CAMPAIGNS}?status=ACTIVE`,
  BRANDS: `${ROUTES.BRANDS}?status=ACTIVE`,
  CSP: ROUTES.CSP,
  EVENTS: ROUTES.EVENTS,
  INTEGRATIONS: ROUTES.INTEGRATIONS,
};
